export const moveCursorToStart = (id: string) => {
  const input = <HTMLInputElement>document?.getElementById(id);

  if (input) {
    input.setSelectionRange(0, 0);
    input.focus();
  }
};
